<app-header *ngIf="menuVisible()"></app-header>
<div class="body-login">
  <div class="container">
    <!-- BRAND LOGO AND COPY -->
    <div class="mylogo col-12" >
      <img *ngIf="!menuVisible()" src="../../../../assets/img/logo.png" width="100%">
      <h5 class="mt-2">Modificar Contraseña</h5>
    </div>
    <br>
    <!-- LOGIN BOX -->
    <form autocomplete="off" class="login-content" [formGroup]="formClave" (ngSubmit)="onCambiarCl()">
        <div class="col-12 form-group">
          <label> <i class="fa fa-unlock-alt"></i> Contraseña Anterior</label>
          <div class="password input-group">
            <input class="form-control"
                  [type]="verPass"
                formControlName="pwdOld"
                placeholder="Password"
                [class.is-invalid]="PasswordNoValido">
                <button class="btn btn-outline-secondary" type="button" id="verClave1" (mousedown)='claveVisible()' (mouseup)='claveOculta()'>
                  <i class="fa" [ngClass]="{'fa-eye': verPass === 'password', 'fa-eye-slash': verPass === 'text'}" ></i>
                </button>

            <small *ngIf="PasswordNoValido"
              class="form-text text-danger">
              El Password debe ser mayor de 4 caracteres
            </small>
          </div>
        </div>
        <div class="col-12 form-group">
          <label> <i class="fa fa-unlock-alt"></i> Contraseña Nueva</label>
          <div class="password input-group">
            <input class="form-control"
                  [type]="verPass"
                formControlName="pwdNew"
                placeholder="Password"
                [class.is-invalid]="PasswordNewNoValido">
                <button class="btn btn-outline-secondary" type="button" id="verClave2" (mousedown)='claveVisible()' (mouseup)='claveOculta()'>
                  <i class="fa" [ngClass]="{'fa-eye': verPass === 'password', 'fa-eye-slash': verPass === 'text'}" ></i>
                </button>

            <small *ngIf="PasswordNewNoValido"
              class="form-text text-danger">
              El Password debe ser mayor de 4 caracteres
            </small>
          </div>
        </div>
        <div class="col-12 form-group">
          <label> <i class="fa fa-unlock-alt"></i> Repetir Contraseña Nueva</label>
          <div class="password input-group">
            <input class="form-control"
                  [type]="verPass"
                formControlName="pwdNew2"
                placeholder="Password"
                [class.is-invalid]="PasswordNew2NoValido">
                <button class="btn btn-outline-secondary" type="button" id="verClave3" (mousedown)='claveVisible()' (mouseup)='claveOculta()'>
                  <i class="fa" [ngClass]="{'fa-eye': verPass === 'password', 'fa-eye-slash': verPass === 'text'}" ></i>
                </button>

            <small *ngIf="PasswordNew2NoValido"
              class="form-text text-danger">
              El Password debe ser mayor de 4 caracteres
            </small>
            <small *ngIf="PasswordIgual"
              class="form-text text-danger">
              La Contraseña Nueva No Es Igual La Confirmacion
            </small>
          </div>
        </div>
        <div class="col-12 form-group text-center">
          <button type="submit" class="form-control btn-primary">Modificar Contraseña</button>
        </div>
    </form>
  </div>
</div>

  <app-footer></app-footer>


